import axios from 'axios';

// Excel Portion Starts
function upload (_this,file) {
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(file.name.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                       // console.log(e.value);
                      //  var edata = this.ProcessExcel(e.target.result);
                        //Read all rows from First Sheet into an JSON array.
                          _this.Exceldata = ProcessExcel(e.target.result);
                          _this.Headers = Object.keys(_this.Exceldata[0]);
                          // added new array ;
                          _this.Headers_cust = Object.keys(_this.Exceldata[0]);
                          _this.Headers_cust.push('--CUSTOM--')
                          _this.Headers_roundOff = Object.keys(_this.Exceldata[0]);
                          _this.Headers_roundOff.push('*Roundoff')
                          //---------------------//
                          _this.IsVisible = true;
                          _this.hlen = Headers.length; 
                    };
                    reader.readAsBinaryString(file);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        var edata = $scope.ProcessExcel(data);
                        $scope.$apply(function () {
                            $scope.Customers = edata;
                            $scope.Headers = Object.keys(edata[0]);
                            $scope.IsVisible = true;
                            $scope.hlen = $scope.Headers.length;
                        });
                    };
                    reader.readAsArrayBuffer($scope.SelectedFile);
                }
            } else {
                $window.alert("This browser does not support HTML5.");
            }
        } else {
            $window.alert("Please upload a valid Excel file.");
        }
};

function ProcessExcel  (data) {
   
    //Read the Excel File data.
    var XLSX = require('xlsx');
    var workbook = XLSX.read(data, {
        type: 'binary'
    });
    //Fetch the name of First Sheet.
    var firstSheet = workbook.SheetNames[0];

    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
   
  
    return excelRows;
    //Display the data from Excel file in Table.
    
};

//Excel Portion Ends

//saveTempalteToDb
function saveJson(url,params){
    axios.post(url,params)
         .then((response)=>{
            alert(response.data.message)
        });
}
// Json_creator Section ends
export{upload,saveJson}